export default "__VITE_PUBLIC_ASSET__57093b47__"